import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import { isNumeric, isUuid, createCustomPropType } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import AdvInput from '../../../CommonComponents/AdvInput';

class InflationChangesView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const { clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate } = this.props;

    const impactTriggerProps = ['whatIf', 'fpId', 'isOPLMonteCarlo'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      goalId,
      clientId,
      loading,
      title,
      groupTitle,
      fpId,
      inflation,
      inflationChanged,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
    } = this.props;
    const { ADV } = window;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <p className="what-if-stress-test-title-description">
            Use this section to see the effect of changes in market conditions.
          </p>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              <li className="what-ifs-form-field what-ifs-stress-test-inflation">
                <AdvInputWrapper hasPercentage className="what-ifs-input-wrapper">
                  <AdvInput
                    type="text"
                    dataType="interest"
                    maxLength="14"
                    onBlur={inflationChanged(clientId, goalId, whatIfTemplate.WhatIfType)}
                    nullable
                    value={ADV.util.formatValue(inflation, 'interest')}
                    className="what-ifs-input"
                  />
                </AdvInputWrapper>
              </li>
            </ul>
          </AdvForm>
        </div>
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
InflationChangesView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

InflationChangesView.propTypes = {
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  inflation: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  inflationChanged: PropTypes.func.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
};

export default InflationChangesView;
